class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.fetchRecommendations();
  }

  fetchRecommendations() {
    const recommendationsUrl = this.dataset.url || window.Shopify.routes.root + 'recommendations/products';

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length > 0) {
          const productId = cart.items[0].product_id;
          const sectionUrl = `${recommendationsUrl}?section_id=cart-drawer-recommendations&product_id=${productId}&limit=4`;

          fetch(sectionUrl)
            .then(response => response.text())
            .then(text => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('.cart-drawer-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.outerHTML;
              }
            });
        } else {
             this.innerHTML = '';
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
